module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/flags/cn/flags_ussr_cn.c9fb45a3.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/flags/cn/flags_ussr_cn.png
// module id = 1104
// module chunks = 16